//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  data() {
      return {
        show: false,
      };
  },
  
  props: {
    title: {
      type: String,
      default: 'A different approach',
    },
    content: {},
    arrow: {
      type: String,
      default: 'A different approach',
    },
    arrowUrl: {
      type: String,
      default: '../../images/arrow.svg',
    },
  },
  
  computed: {

  },
  
  watch: {

  },
  
  methods: {

  },
  
  components: {

  },
  
  created() {
    
  },
  mounted() {

  },
};




// WEBPACK FOOTER //
// ./scripts/vue/PageBanner.vue